
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Ref, Prop } from "vue-property-decorator";
    import { VForm } from "@/vForm";
    import HtmlEditor from "@/vue/components/HtmlEditor.vue";
    import { TextOptions } from "@/model/pagePartOptions/TextOptions";
    import { IMapplicOption, MapplicOption } from "@/model/MapplicOption";

    @Component({ components: { HtmlEditor } })
    export default class TextPartEdit extends Vue {

        @Ref("editForm")
        readonly editForm!: VForm;

        @Prop({ required: true })
        pagePartOptions!: TextOptions;

        @Prop({ default: () => [] })
        mapplicOptionList!: Array<MapplicOption>;

        validate(): boolean {
            return this.editForm.validate();
        }
    }
